var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_6039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 4.58191C12.8708 4.69977 13.0401 4.86966 13.1572 5.07425C13.2743 5.27885 13.3351 5.51084 13.3333 5.74657V10.1039C13.3332 10.3417 13.2696 10.5751 13.149 10.78C13.0284 10.9849 12.8552 11.1538 12.6473 11.2692L8.64729 13.8246C8.44926 13.9345 8.22648 13.9923 7.99996 13.9923C7.77344 13.9923 7.55066 13.9345 7.35263 13.8246L3.35263 11.2692C3.14486 11.1539 2.97171 10.985 2.8511 10.7803C2.73049 10.5755 2.6668 10.3422 2.66663 10.1046V5.74657C2.66668 5.50881 2.73032 5.27539 2.85093 5.07049C2.97155 4.86559 3.14476 4.69667 3.35263 4.58124L7.35263 2.19991C7.5565 2.08642 7.78596 2.02686 8.01929 2.02686C8.25262 2.02686 8.48209 2.08642 8.68596 2.19991L12.686 4.58191H12.6666V4.58191Z",
    stroke: "#232633",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    stroke: "#232633",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_6039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.deb518d2f2bb8f654c15074dd125e71e.svg";
export { ForwardRef as ReactComponent };